<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden bg-repeat min-h-12/12 classic-min-h"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="data.navigation.compact"
  [opened]="!isScreenSmall">
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="flex items-center h-40 pb-4 w-full justify-center">
      <a [routerLink]="['/home']">
        <img class="w-30" alt="IAPMO SCB Certification Management Database" src="assets/images/logo/logo_SCB.jpg">
      </a>
    </div>
  </ng-container>
</fuse-vertical-navigation>
<div class="flex flex-col flex-auto w-full min-w-0">
  <div
    class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <button
      mat-icon-button
      (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>
    <div class="flex items-center pl-2 ml-auto space-x-2">
      <div class="hidden md:flex">
        <fuse-fullscreen></fuse-fullscreen>
      </div>
      <user-menu></user-menu>
    </div>
  </div>

  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <div
    class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
    <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
  </div>
</div>
